import React, {useEffect, useState} from 'react'
import Modal from '../Modal'
import NewModal from '../NewModal/NewModal'
import Form from '../Form/Form'
import FormInput from '../Inputs/FormInput/FormInput'
import {useForm} from 'react-hook-form'
import ApiSearchInput from './APISearchInput'
import {observer} from 'mobx-react'
import ModalsStore from '../Pages/Modals.store'
import AttentionGenerator from '../Form/AttentionGenerator'
import styled from "styled-components";
import CheckboxInput from "../Inputs/CheckboxInput/CheckboxInput";
import RadioInput from "../Inputs/RadioInput/RadioInput";



const QuizVeterinarModal = observer(() => {
    const NAME = `QuizVeterinarModal`
    const {data, methods} = ModalsStore.Modals[NAME]
    const [status, setStatus] = useState()
    const [error, setError] = useState({})
    const [prediagnos, setPrediagnos] = useState(data.initialForm.prediagnos)
    const [sentby, setSentby] = useState(data.initialForm.sentby)
    const [anamnes, setAnamnes] = useState(data.initialForm.anamnes)
    const [rdoza, setRdoza] = useState(data.initialForm.rdoza)
	

    const {errors, setValue, watch, register, handleSubmit} = useForm(
        {defaultValues: data.initialForm})


    return (
        <Modal mobile={true}>
            <NewModal
                completed={status}
                completedText={'Сохранено!'}
                completedButtonText={'Продолжить'}
                title={'Анкета ветеринар'}
                closeHandler={_ => ModalsStore.closeModal(NAME)}
				style={{width: '90%', height:'90%',maxHeight:'100%'}}
				hideErrors={true}
				containerStyle={{width: '90%', height:'100%',maxHeight:'100%'}}
            >

                <Form submitHandler={handleSubmit(async (formData) => {
                    await methods.submit({...formData, 
							prediagnos, sentby,anamnes,rdoza,
						}) // 
                        .then(response => response !== 'success'
                            ? setError({
                                type: 'def',
                                message: 'Ой. У нас что-то пошло не так. Повторите свою попытку позже.'
                            })
                            : setStatus(true))

                })} submitButtonText={'Сохранить'}>
					<div style={{flex:1,flexDirection:'column',display: 'flex',}}>
						<p style={{marginTop: '15px'}}>Предварительный диагноз</p>
						<textarea value={prediagnos} onChange={(event) => {setPrediagnos(event.target.value)}} 
							style={{width:'100%',height:'120px'}}/>
						<p style={{marginTop: '15px'}}>Кто направил</p>
						<textarea value={sentby} onChange={(event) => {setSentby(event.target.value)}} 
							style={{width:'100%',height:'120px'}}/>
						<p style={{marginTop: '15px'}}>Анамнез</p>
						<textarea value={anamnes} onChange={(event) => {setAnamnes(event.target.value)}} 
							style={{width:'100%',height:'120px'}}/>
						<p style={{marginTop: '15px'}}>Доза ЭЭД, млЗв</p>
						<input value={rdoza} onChange={(event) => {setRdoza(event.target.value)}} 
							style={{width:'100%'}}/>
					</div>
                </Form>
            </NewModal>
        </Modal>
    )
})
const StyledAttention = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  font-size: 12px;
`

export default QuizVeterinarModal
